import * as React from 'react';
import { widgetType as WidgetType } from '../bazzarvoice-widget.props.autogenerated';
import MsDyn365 from '@msdyn365-commerce/core';
import classnames from 'classnames';

type BazzarvoiceProps = {
    itemId?: string;
    widgetType?: WidgetType;
    className?: string;
};

const Bazzarvoice = (props: BazzarvoiceProps) => {
    const { itemId, widgetType, className } = props;
    const divRef = React.useRef<HTMLDivElement>(null);
    const [initialized, setInitialized] = React.useState(false);

    const isBrowser = MsDyn365.isBrowser;
    React.useEffect(() => {
        const div = divRef.current;
        if (!initialized && isBrowser && div && itemId && widgetType) {
            setInitialized(true);

            div.innerHTML = `<div data-bv-show="${widgetType}" data-bv-product-id="${itemId}" />`;
        }
    }, [isBrowser, initialized, itemId, widgetType, divRef]);

    return (
        <div className={classnames('hei-bazzarvoice-widget', className)}>
            <div ref={divRef} />
        </div>
    );
};

export default Bazzarvoice;
